<div class="outer w-100" *ngIf="shouldLoad" style="padding-bottom: 30px;">

  <app-recommended-news></app-recommended-news>
  <app-recommended-news [title]="'猜你喜欢'" [isNews]="false"></app-recommended-news>

  <app-classified-top-videos *ngIf="recentlyWatchedVideos.length>=8" [title]="'历史记录'" [showHistoryButton]="true"
    [link]="'/user/watch-history'" [blockTitleAsLink]="false" [recommendedVideos]="recentlyWatchedVideos">
  </app-classified-top-videos>

  <app-classified-top-videos *ngFor="let category of categories;let i = index" [category]="category"
    [cid]="category.cid" [title]="category.title" [link]="category.link" [linkParams]="category.linkParams"
    [slug]="category.slug" [recommendedVideos]="list[(category.sysKey || category.slug) +'List']">
  </app-classified-top-videos>

  <app-tv-live [liveList]="list['liveList']"></app-tv-live>

  <div class="container" [lazy] (onScroll)="triggerGetHot($event)" style="min-height: 675px;">
    <app-discovery-in-home *ngIf="discoverLoaded"></app-discovery-in-home>
  </div>

  <div class="new-list" *ngFor="let category of newscategories;let i = index" [category]="category" [cid]="category.cid"
    [title]="category.title" [link]="category.cid" [slug]="category.slug"
    [recommendedVideos]="list[(category.sysKey || category.slug) +'List']">
  </div>

</div>
<app-footer class="d-block" *ngIf="shouldLoad"></app-footer>